import React from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import Button from '../../components/bootstrap/Button';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Label from '../../components/bootstrap/forms/Label';

const Login = () => {
	return (
		<React.Fragment>
			<PageWrapper title='Login'>
				<div className='row align-items-center justify-content-center'>
					<div className='col-xl-6 col-sm-12 left-aside'></div>
					<div className='col-xl-6 col-sm-12 right-aside'>
						<div className='col-xl-6'>
							<img
								src={require('../../assets/img/logo.png')}
								width='50'
								alt='Liiftsocial'
							/>
							<h3 className='greeting-text'>Welcome back, Fenil</h3>
							<p className='greeting-subtext'>
								Welcome back! Please enter your credentials
							</p>
							<form className='row g-4 login-form'>
								<div className='col-12'>
									<Label htmlFor='login-email'>Email</Label>
									<FormGroup id='login-email' isFloating label='Your email'>
										<input type='email' className='form-control' />
									</FormGroup>
								</div>
								<div className='col-12'>
									<Label htmlFor='login-password'>Password</Label>
									<FormGroup id='login-password' isFloating label='Password'>
										<input type='password' className='form-control' />
									</FormGroup>
								</div>
								<div className='col-12'>
									<div
										className='d-flex align-items-center'
										style={{ justifyContent: 'space-between' }}>
										<div className='d-flex'>
											<input type='checkbox' id='rememberMe' />
											<p className='remember-me-text'>Remember Me</p>
										</div>
										<a href='/forgot-password' className='forgot-pass-text'>
											Forgot Password
										</a>
									</div>
								</div>
								<div className='col-12 mt-5'>
									<Button color='primary' className='w-100 py-3'>
										Login
									</Button>
								</div>
							</form>
							<div className='col-12 mt-4'>
								<div className='d-flex' style={{ justifyContent: 'center' }}>
									<p>Don't have an account? </p>
									<a
										href='/register'
										className='forgot-pass-text'
										style={{ marginLeft: '5px' }}>
										Sign up
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</PageWrapper>
		</React.Fragment>
	);
};

export default Login;
